import LazyLoad from "vanilla-lazyload";

import Glide from "@glidejs/glide";

import hamburger from "./lib/hamburger";

import popUp from "./lib/popUp";

import scrollToElement from "./lib/scrollToElement";

import acfMap from "./lib/acfMap";

import stickElem from "./lib/stickElem";

import filterProp from "./lib/filterProp";

import customSelect from "./lib/customSelect";

import showHide from "./lib/showHide";

import cfSevenValid from "./lib/cfSevenValid";

import resetForm from "./lib/resetForm";

import dataLayerEvents from "./lib/dataLayerEvents";

window.Glide = Glide;

window.acfMap = acfMap;

window.stickElem = stickElem;

const lazyLoadInstance = new LazyLoad({
  elements_selector: ".lazy",
  load_delay: 300,
});

window.lazyLoadInstance = lazyLoadInstance;

hamburger(".hamburger", ".header_menu");

popUp();

scrollToElement();

filterProp();

customSelect();

acfMap();

showHide();

cfSevenValid();

resetForm("#filter");

dataLayerEvents();

if (window.innerWidth > 1023) {
  stickElem(".stick-elem-feat", ".sticky-box", 20);
}

if (window.innerWidth > 1439) {
  stickElem("#response-map", ".property-arch__left", 0);
  stickElem(".property-page__right", ".sticki-box-two", 20);
}
